<template>
    <div>
        <baidu-map class="map" :center="{lng:lng,lat:lat}" :zoom="map.zoom" @ready="handler">
            <!--缩放-->
            <!-- <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation> -->
            <!--定位-->
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
            <!--点-->
            <bm-marker :position="{lng:lng,lat:lat}" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
                <!--提示信息-->
                <bm-info-window :show="map.show">
                    <p style="font-size:10px;display:none">{{countryname}}</p>
                     <p style="font-size:10px;margin-top:5px">地址：{{address}}</p>
                      <p style="font-size:10px">电话：{{iphone}}</p>
                </bm-info-window>
            </bm-marker>
        </baidu-map>
    </div>
</template>
 
<script>
    export default {
        name: "bdmap",
        data: () => ({
            map:{
                center: {lng:116.470946, lat:39.96615},
                zoom: 17,
                show: true,
                dragging: true
            },
        }),
        methods: {
            handler ({BMap, map}) {
                let me = this;
                console.log(BMap, map)
                // 鼠标缩放
                map.enableScrollWheelZoom(false);
                // 点击事件获取经纬度
                map.addEventListener('click', function (e) {
                    console.log(e.point.lng, e.point.lat)
                });
            },
        },
        props:{
            countryname:{
                default:'北京位来小猎科技有限公司'
            },
            address:{
                default:'北京市朝阳区霄云中心A座10层'
            },
            iphone:{
                default:'400-603-0166'
            },
            lng:{
                default:116.470946
            },
            lat:{
                default:39.96615
            }
        },
    }
</script>
 
<style scoped>
    .map {
        width: 100%;
        height: 400px;
    }
</style>


// WEBPACK FOOTER //
// src/components/util/bdmap.vue